import { useState } from "react";
import ProductVideoPlayerModal from "./ProductVideoPlayerModal";
import { formatDate } from "utils/dateFormat";

const STATUS_LABEL = {
    pending: "قيد المراجعة",
    approved: "معتمد",
    rejected: "مرفوض",
};

const ProductVideoRow = ({
    video,
    scope,
    onApprove,
    onReject,
    onDelete,
    onEdit,
    onOpenProduct,
}) => {
    const [playerOpen, setPlayerOpen] = useState(false);
    const [thumbFailed, setThumbFailed] = useState(false);
    const [rejectOpen, setRejectOpen] = useState(false);
    const [rejectReason, setRejectReason] = useState("");

    const handleReject = () => {
        onReject(rejectReason);
        setRejectOpen(false);
        setRejectReason("");
    };

    return (
        <li className="video-card">
            <div
                className="thumb"
                role="button"
                tabIndex={0}
                onClick={() => setPlayerOpen(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") setPlayerOpen(true);
                }}
            >
                {video.thumbnailUrl ? (
                    <img src={video.thumbnailUrl} alt="" />
                ) : thumbFailed ? (
                    // Poster frame couldn't be decoded — a missing object, or HEVC
                    // on a browser without it. Say so instead of leaving an
                    // unexplained black box.
                    <span className="thumb-error" title="تعذّر عرض المعاينة">
                        ⚠
                    </span>
                ) : (
                    // Most rows have no uploaded thumbnail, so the tile falls back
                    // to the video itself. The #t=0.1 fragment pins that to a
                    // 0.1s seek: browsers largely ignore `preload="metadata"` here
                    // and buffer the whole file otherwise (measured in Chrome 148:
                    // 24.4s of video buffered without the fragment vs 3.4s with
                    // it — per row, on a page that lists the whole library).
                    <video
                        src={`${video.videoUrl}#t=0.1`}
                        preload="metadata"
                        muted
                        playsInline
                        onError={() => setThumbFailed(true)}
                    />
                )}
                <span className="play-icon">▶︎</span>
            </div>

            <div className="meta">
                <h3>{video.product?.title || `Product #${video.productId}`}</h3>
                {video.caption ? <p className="caption">{video.caption}</p> : null}
                <p className="subline">
                    {scope === "admin" && video.vendor?.name ? (
                        <>المطعم: {video.vendor.name} · </>
                    ) : null}
                    تم الرفع {formatDate(video.createdAt)}
                </p>
                <span className={`badge ${video.status}`}>{STATUS_LABEL[video.status]}</span>
                {video.status === "rejected" && video.adminNotes ? (
                    <p className="notes">السبب: {video.adminNotes}</p>
                ) : null}
                {video.status === "approved" ? (
                    <p className="views">{video.viewCount ?? 0} مشاهدة</p>
                ) : null}
            </div>

            <div className="actions">
                {scope === "admin" && video.status === "pending" ? (
                    <>
                        <button className="approve" onClick={onApprove}>
                            اعتماد
                        </button>
                        <button className="reject" onClick={() => setRejectOpen(true)}>
                            رفض
                        </button>
                    </>
                ) : null}
                {scope === "admin" && video.status === "approved" ? (
                    <button className="reject" onClick={() => setRejectOpen(true)}>
                        إلغاء الاعتماد
                    </button>
                ) : null}
                {scope === "admin" && video.product?.id && onOpenProduct ? (
                    <button onClick={onOpenProduct}>عرض المنتج</button>
                ) : null}
                {onEdit ? <button onClick={onEdit}>تعديل</button> : null}
                <button className="danger" onClick={onDelete}>
                    حذف
                </button>
            </div>

            {rejectOpen ? (
                <div className="reject-inline">
                    <input
                        type="text"
                        placeholder="سبب الرفض (اختياري)"
                        value={rejectReason}
                        onChange={(e) => setRejectReason(e.target.value)}
                        maxLength={200}
                        autoFocus
                    />
                    <button className="reject" onClick={handleReject}>
                        تأكيد
                    </button>
                    <button onClick={() => setRejectOpen(false)}>إلغاء</button>
                </div>
            ) : null}

            {playerOpen ? (
                <ProductVideoPlayerModal video={video} onClose={() => setPlayerOpen(false)} />
            ) : null}
        </li>
    );
};

export default ProductVideoRow;
